import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Users, MessageSquare } from 'lucide-react';
export function Bonuses() {
  return <section className="bg-slate-900 py-20 lg:py-28 relative overflow-hidden" data-id="element-38">
      <div className="absolute inset-0 opacity-5" data-id="element-39">
        <div className="absolute top-0 right-0 h-full w-1/2 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-400 via-transparent to-transparent" data-id="element-40"></div>
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="mx-auto max-w-4xl text-center mb-16" data-id="element-42">
          <div className="inline-flex items-center gap-2 rounded-full bg-amber-400/20 px-4 py-2 text-amber-400 mb-6" data-id="element-43">
            <Gift className="h-5 w-5" data-id="element-44" />
            <span className="font-bold tracking-wide uppercase" data-id="element-45">
              Oferta Especial
            </span>
          </div>
          <h2 className="mb-6 text-3xl text-white md:text-4xl lg:text-5xl font-display" data-id="element-46">
            BONUS PROFESIONALES
            <br data-id="element-47" />
            <span className="text-amber-400" data-id="element-48">GRATIS POR EL DÍA DE HOY</span>
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2 max-w-5xl mx-auto" data-id="element-49">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative rounded-3xl bg-gradient-to-b from-slate-800 to-slate-900 p-1 border border-slate-700" data-id="element-50">
            <div className="absolute -top-4 -right-4 rotate-12 rounded-lg bg-amber-400 px-4 py-2 font-black text-slate-900 shadow-lg border-2 border-white z-10" data-id="element-51">
              ¡Gratis Hoy!
            </div>
            <div className="h-full rounded-[23px] bg-slate-800 p-8" data-id="element-52">
              <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-700 text-amber-400" data-id="element-53">
                <Users className="h-8 w-8" data-id="element-54" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2 uppercase" data-id="element-55">
                BONUS #1
              </h3>
              <h4 className="text-xl font-medium text-amber-400 mb-4" data-id="element-56">
                Comunicación con el cuerpo técnico
              </h4>
              <p className="text-slate-300 font-medium mb-4" data-id="element-57">
                Plantilla de reporte profesional lista para usar.
              </p>
              <p className="text-slate-400 mb-6 text-sm" data-id="element-58">
                El método trabaja la intervención con el deportista, pero en el
                deporte real también necesitás comunicarte con entrenadores.
                Este bonus te ayuda a responder con claridad cuando el cuerpo
                técnico te pregunta:
              </p>
              <div className="bg-slate-900/50 rounded-xl p-4 mb-6 border border-slate-700" data-id="element-59">
                <p className="text-emerald-400 font-medium italic text-sm text-center" data-id="element-60">
                  "¿Cómo lo ves?" "¿Está preparado para competir?" "¿Qué tenemos
                  que hacer con él?"
                </p>
              </div>
              <div className="space-y-2" data-id="element-61">
                <p className="text-white font-bold text-sm mb-3" data-id="element-62">Incluye:</p>
                {['plantilla de reporte profesional;', 'tabla "evitar decir / mejor decir";', 'nota de confidencialidad;', 'frases listas para usar con entrenadores;', 'checklist antes de enviar un informe.'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-slate-300" data-id="element-63">
                    <div className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" data-id="element-64" />
                    <span data-id="element-65">{item}</span>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative rounded-3xl bg-gradient-to-b from-slate-800 to-slate-900 p-1 border border-slate-700" data-id="element-66">
            <div className="absolute -top-4 -right-4 rotate-12 rounded-lg bg-amber-400 px-4 py-2 font-black text-slate-900 shadow-lg border-2 border-white z-10" data-id="element-67">
              ¡Gratis Hoy!
            </div>
            <div className="h-full rounded-[23px] bg-slate-800 p-8" data-id="element-68">
              <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-700 text-amber-400" data-id="element-69">
                <MessageSquare className="h-8 w-8" data-id="element-70" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2 uppercase" data-id="element-71">
                BONUS #2
              </h3>
              <h4 className="text-xl font-medium text-amber-400 mb-4" data-id="element-72">
                Protocolo de primera sesión
              </h4>
              <p className="text-slate-300 font-medium mb-4" data-id="element-73">
                Guía específica para el primer contacto con el deportista.
              </p>

              <div className="space-y-2 mb-6" data-id="element-74">
                <p className="text-white font-bold text-sm mb-3" data-id="element-75">Incluye:</p>
                {['guion de apertura;', 'encuadre de confidencialidad;', 'preguntas por bloques;', 'ficha editable de primera sesión;', 'matriz de prioridad inicial;', 'guion de cierre;', 'tareas iniciales entre sesiones.'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-slate-300" data-id="element-76">
                    <div className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" data-id="element-77" />
                    <span data-id="element-78">{item}</span>
                  </div>)}
              </div>

              <div className="mt-auto bg-amber-400/10 rounded-xl p-4 border border-amber-400/20" data-id="element-79">
                <p className="text-amber-400 font-medium text-sm text-center" data-id="element-80">
                  Para que no empieces improvisando desde el primer encuentro.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}